import(
  /* webpackChunkName: "noncritical" */
  /* webpackMode: "lazy" */
  "./nonCritical"
);
